  $(document).ready(function(){
    $('.slider-nav').slick({ 
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      infinite: true,
      dots: true,
      arrows: true,
      responsive: [{
  	    breakpoint: 769,
  	    settings: {
  	      arrows: false
	    }
      }]
    });
    $('.slick-related').slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: true,
      responsive: [{
  	    breakpoint: 769,
  	    settings: {
  	      slidesToShow: 2,
          slidesToScroll: 2
	    }
      }]
    });
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    } 
    else {
      
      
    };
  });

  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = "fit-content";
      } 
    });
  }
  
  $(".stamped-product-reviews-badge").click(function() {
    $(".reviews-panel").css('maxHeight','fit-content');
  });
  
  var _BISConfig = _BISConfig || {}; 
  _BISConfig.button = { visible: false };   
      
  var apConfig = {
    priceSelector: '.product-meta',
    locale: 'en_US',
    currency: 'USD',
    amount: null,
    minMaxThreshold: {
      min: 3500,
      max: 100000, 
    },
  }; 
    
  $(window).on('load', function() {
    var afterpay_product_type = '';                     
    if (afterpay_product_type == "Gift Card") {
      apConfig.giftCard = "true";
    }
    new presentAfterpay(apConfig).init();    

    $(".zoomImg").attr("data-pin-nopin","true");
    $(".ls-image").attr("data-pin-nopin","No hover");
  });
    
  var iframe = $('#vimeo-player')[0];
  var player = $f(iframe);

  $('#pause').click(function() {
    player.api('pause');
  });

  $('#play').click(function(){
    player.api('play');
  });
    
  $('.tabs-nav a').on('click', function (event) {
    event.preventDefault();
    
    $('.tab-active').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage .tabs-content').hide();
    $($(this).attr('href')).show();
  });

  $('.tabs-nav a:first').trigger('click');
  
  $('.ktabs-nav a').on('click', function (event) {
    event.preventDefault();
    
    $('.ktab-active').removeClass('ktab-active');
    $(this).parent().addClass('ktab-active');
    $('.ktabs-stage .ktabs-content').hide();
    $($(this).attr('href')).show();
  });

  $('.ktabs-nav a:first').trigger('click');